var _a;
export var TalColumn = {
    domain: 'Domain',
    accountCategory: 'Account Category',
    accountCategory2: 'Account Category 2',
    accountCategory3: 'Account Category 3',
    companyName: 'Company Name',
    industry: 'Industry',
    region: 'Region',
    revenueSize: 'Revenue Size',
    employeeSize: 'Employee Size',
    clientProvidedAccount: 'Client Provided Account',
    lookalikeAccount: 'Lookalike Account',
};
export var TalColumnValidation = (_a = {},
    _a[TalColumn.domain] = { required: true },
    _a[TalColumn.companyName] = { required: false },
    _a[TalColumn.accountCategory] = { required: false },
    _a[TalColumn.accountCategory2] = { required: false },
    _a[TalColumn.accountCategory3] = { required: false },
    _a[TalColumn.industry] = { required: false },
    _a[TalColumn.region] = { required: false },
    _a[TalColumn.revenueSize] = { required: false },
    _a[TalColumn.employeeSize] = { required: false },
    _a[TalColumn.clientProvidedAccount] = { required: false, boolean: true },
    _a[TalColumn.lookalikeAccount] = { required: false, boolean: true },
    _a);
export var TalColumnValidationEntries = Object.entries(TalColumnValidation);
export var TalColumnCount = TalColumnValidationEntries.length;
export var TalColumns = TalColumnValidationEntries.map(function (_a) {
    var columnName = _a[0];
    return columnName;
});
export var TalColumnsString = TalColumns.join(',');
export var TalColumnTemplate = Object.fromEntries(TalColumnValidationEntries.map(function (_a) {
    var columnName = _a[0], columnConfig = _a[1];
    var values = [];
    if (columnConfig.required) {
        values.push('required');
    }
    if ('boolean' in columnConfig && columnConfig.boolean) {
        values.push('yes or no');
    }
    return [columnName, values.length > 0 ? "(".concat(values.join(', '), ")") : ''];
}));
//# sourceMappingURL=talColumns.js.map